import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ModalData } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { QuotaInfoModalInterface } from '../../../shared/interfaces/manage-quotas.interface';
import { Quotas, Survey } from '../../../shared/interfaces/survey.interface';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { BuyerApiService } from '../../../shared/services/buyer-api/survey.service';
import { BlackBoxService } from '../../../shared/services/pure-price/black-box.service';
import { SocketService } from '../../../shared/services/socket/socket.service';
import { Subscription } from 'rxjs';
import { PurePriceService } from '../../../shared/services/pure-price/pure-price.service';

@Component({
  selector: 'ps-ui-quotas-info-modal',
  templateUrl: './quotas-info-modal.component.html',
  styleUrls: ['./quotas-info-modal.component.css'],
})
export class QuotasInfoModalComponent implements OnInit, OnDestroy {
  public quotaInfoModal!: QuotaInfoModalInterface;
  public surveyDetail!: Survey;
  public item: any;
  public quotaActive = { tab: 'quota_metrics' };
  public buyer: string | undefined = '';
  public operator: string | undefined = '';
  public cpi: number = 0;
  public editStateModal: boolean = false;
  private _subscriptions: Subscription = new Subscription();
  constructor(
    @Inject(ModalData)
    private _modalData: {
      item: Quotas;
      survey: Survey;
    },
    private _auth: AuthService,
    private _buyerApi: BuyerApiService,
    private _toastr: ToasterService,
    private _blackBoxService: BlackBoxService,
    private _socketService: SocketService,
    private _purePriceService: PurePriceService
  ) {}

  ngOnInit() {
    this.surveyDetail = this._modalData.survey;
    this.item = this._modalData.item;
    this.buyer = this._auth.user?.buyerAcssLvls;
    this.operator = this._auth.user?.operatorAcssLvls;
    this._openInfoModel();
    this._socketSubscriptions();
  }
  private _openInfoModel() {
    this.quotaInfoModal = this.item;
    if (this.item.name && this.item.name.length > 0) {
      this.quotaInfoModal.qualificationName = this.item.name;
    } else if (this.item.quota_title && this.item.quota_title.length > 0) {
      this.quotaInfoModal.editedQuota = this.item.quota_title;
    } else {
      this.quotaInfoModal.nestedObj = this.item.combinedOptions;
    }
    this.quotaInfoModal.qbpEnabled = this.surveyDetail.qbp
      ? this.surveyDetail.qbp.selectedQuotaIds.includes(this.item.ps_quota_id)
      : false;
    if (this.item.qbp) {
      this.quotaInfoModal.cpi = this.item.qbp.cpi;
      this.cpi = this.quotaInfoModal.cpi;
      const mappedSurveyData = this._blackBoxService.mapIntoBlackboxSurveyData(
        this.surveyDetail
      );
      const blackBoxPayload = this._blackBoxService.generateBlackBoxPayload(
        this.item,
        mappedSurveyData
      );
      this._blackBoxService
        .getRecommendedCpi(blackBoxPayload)
        .subscribe((result) => {
          this.quotaInfoModal.priceRecommendCpi = result.price_recommendation;
        });
      this.quotaInfoModal.qbpEnabled = this.item.qbp.enabled
        ? this.item.qbp.enabled
        : this.quotaInfoModal.qbpEnabled;
      this.quotaInfoModal.childSurveyId = this.item.qbp.surveyId
        ? this.item.qbp.surveyId
        : '';
    }
  }

  private _socketSubscriptions() {
    this._subscriptions.add(
      this._socketService.quotaCpiUpdate$.subscribe((data) => {
        if (
          Number(this.surveyDetail.id) === Number(data.surveyId) &&
          this.item.ps_quota_id === data.quotaId &&
          this.item.qbp
        ) {
          this.item.qbp.cpi = data.cpi;
          this.quotaInfoModal.cpi = this.item.qbp.cpi;
          this.cpi = this.quotaInfoModal.cpi;
          this.setTabForQuota('pricing');
        }
      })
    );
  }

  public setTabForQuota(newTab: string) {
    this.quotaActive.tab = newTab;
  }

  public supConversion(quotaInfoModal: QuotaInfoModalInterface) {
    if (
      quotaInfoModal.achieved != 0 &&
      quotaInfoModal.buyer_valid_clks - quotaInfoModal.bip != 0
    ) {
      const supValue =
        (quotaInfoModal.achieved * 100) /
        (quotaInfoModal.buyer_valid_clks - quotaInfoModal.bip);
      if (supValue > 100) {
        return '100%';
      } else {
        return Math.round(supValue) + '%';
      }
    } else {
      return '-';
    }
  }

  isSetTabForQuota(tab: string) {
    return this.quotaActive.tab === tab;
  }

  save() {
    if (this.quotaInfoModal.cpi < 0) {
      return false;
    }
    const payload = [
      {
        op: 'replace',
        path: '/cpi',
        value: this.cpi,
      },
    ];
    this._buyerApi
      .updateQuotaData(this.surveyDetail.id, this.item.ps_quota_id, payload)
      .subscribe(
        (result) => {
          this.editStateModal = false;
          this.quotaInfoModal.cpi = this.cpi;
          this.item.qbp.cpi = this.cpi;
          this._toastr.success('Success! CPI has been updated');
          return true;
        },
        (err: Error) => {
          this._toastr.error(err.message);
          return false;
        }
      );
    return true;
  }

  updateQuotaCpi() {
    const payload = [
      {
        op: 'replace',
        path: '/cpi',
        value: this.quotaInfoModal.priceRecommendCpi,
      },
    ];
    this._buyerApi
      .updateQuotaData(this.surveyDetail.id, this.item.ps_quota_id, payload)
      .subscribe(
        (result) => {
          this.editStateModal = false;
          this.quotaInfoModal.cpi = this.quotaInfoModal.priceRecommendCpi;
          this._toastr.success('Success! CPI has been updated');
          return true;
        },
        (err: Error) => {
          this._toastr.error(err.message);
          return false;
        }
      );
    this._purePriceService.pushApplyPriceRecoButtonCount(this.surveyDetail.id);
    return true;
  }

  numberOnly(event: any, allowDecimal: boolean = false): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    let restrictedPattern: boolean =
      charCode > 31 && (charCode < 48 || charCode > 57);
    if (allowDecimal) {
      restrictedPattern = restrictedPattern && charCode != 46;
    }
    return !restrictedPattern;
  }

  toggle() {
    this.editStateModal = !this.editStateModal;
    this.cpi = this.quotaInfoModal.cpi;
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
